
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"chevron-right_svg__a","maskUnits":"userSpaceOnUse","x":"8","y":"5","width":"9","height":"14"}},[_c('path',{attrs:{"d":"M9.459 5.19l-.627.62a.372.372 0 000 .53L14.555 12l-5.723 5.66a.372.372 0 000 .53l.627.62c.148.146.39.146.538 0l6.632-6.545a.372.372 0 000-.53L9.997 5.191a.384.384 0 00-.538 0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#chevron-right_svg__a)"}},[_c('path',{attrs:{"fill":"#FF5F3C","d":"M24.892 24H.57V0h24.323z"}})])])
          )
        }
      }
    